export const INVOICE_CC_SCOPE_THIS_INVOICE = "THIS_INVOICE" as const;
export const INVOICE_CC_SCOPE_CUSTOMER = "CUSTOMER" as const;
export const INVOICE_CC_SCOPE_ENTITY = "ENTITY" as const;

export type InvoiceCcScope =
  | typeof INVOICE_CC_SCOPE_THIS_INVOICE
  | typeof INVOICE_CC_SCOPE_CUSTOMER
  | typeof INVOICE_CC_SCOPE_ENTITY;

export const INVOICE_CC_SCOPE_VALUES: InvoiceCcScope[] = [
  INVOICE_CC_SCOPE_THIS_INVOICE,
  INVOICE_CC_SCOPE_CUSTOMER,
  INVOICE_CC_SCOPE_ENTITY,
];
